export default [
  {
    path: ':orgURL?',
    name: 'register-view',
    component: () => import('@/views/register/RegisterView.vue'),
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Register',
      renderFooter: false,
    },
  },
];
